import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { FabricSqlTableDataset } from 'shell-models-lib';
import { SqlServerTableDatasetAdapter } from './sql-server-table.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricSqlTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            linkedService: '*',
            connectionSettings: '*',
            typeProperties: {
                tableName: '*',
                schema: '*',
                table: '*'
            }
        }
    }
})
export class FabricSqlTableDatasetAdapter extends SqlServerTableDatasetAdapter {
    protected async _toResource(dataset: FabricSqlTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(FabricSqlTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: FabricSqlTableDataset): Promise<FabricSqlTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, FabricSqlTableDataset.MODEL);
    }
}
